import { createStore, applyMiddleware, combineReducers } from 'redux';
import { thunk } from 'redux-thunk';

import app from './dux/app';

export default function AppStore( experiences ) {
    /*******************************************************************************
     *  Gather all the reducers
     */
    const allReducers = { app };
    // add all the experience reducers
    experiences.forEach( e => {
        if ( e.reducers ) {
            Object.keys( e.reducers ).forEach( name => {
                allReducers[ name ] = e.reducers[ name ];
            } );
        }
    } );

    const reducer = combineReducers( allReducers );

    const middleware = [ thunk ];

    return createStore(
        reducer,
        applyMiddleware( ...middleware )
    );
}
